import { logEvent } from "firebase/analytics";
import { analytics } from "../../config/firebaseConfig";

export const GAEventTrack = ({ event, data = {} }) => {
  logEvent(analytics, event, { ...data });
};
